import {
  bynderImageProjection,
  compactBynderImageProjection,
  compatibleImageProjection,
  spreadBynderImageProjection,
} from '@workspace/sanity-base/queries/projection';

/**
 * Re-exported for this app's query files. Imported unaliased on purpose: Sanity typegen
 * cannot follow an aliased import or a re-export across workspace packages.
 * See packages/sanity-base/queries/projection.ts for the rules these helpers must obey.
 */
export { bynderImageProjection, compatibleImageProjection, spreadBynderImageProjection };

export const computedInternalUrl = `
  select(
    defined(parentPage->parentPage->slug.current) => "/products/" + parentPage->parentPage->slug.current + "/" + parentPage->slug.current + "/" + slug.current,
    defined(parentPage->slug.current) => "/products/" + parentPage->slug.current + "/" + slug.current,
    _type == "productsList" => "/products/" + subcategory->parentCategory->slug.current + "/" + subcategory->slug.current,
    _type == "product" && defined(subcategory->parentCategory->slug.current) => "/products/" + subcategory->parentCategory->slug.current + "/" + subcategory->slug.current + "/" + slug.current,
    _type == "structaProductLevel1" => "/products/" + slug.current,
    _type == "articlesList" => "/" + select(
      type == "blogs" => "blog",
      type
    ),
    _type == "article" && defined(type) && type == "blogs" => "/blog/" + slug.current,
    _type == "article" && defined(type) => "/" + type + "/" + slug.current,
    _type == "documentPage" => "/documents/" + slug.current,
    _type == "faqs" => "/faq",
    _type == "contactUs" => "/contact-us",
    _type == "storeLocator" => "/store-locator",
    _type == "homePage" => "/",
    "/" + slug.current
  )
`;

export const internalReferenceUrl = `
  select(
    type == "internal" =>
      internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    url
  )
`;

export const directInternalReferenceUrl = `
  select(
    link.type == "internal" =>
      link.internalReference->{
        "computedUrl": ${computedInternalUrl}
      }.computedUrl,
    link.type == "external" => link.url
  )
`;

export const bynderImageUrl = (field: string) => `
  coalesce(
    ${field}.selectedUrl,
    ${field}.url,
    ${field}.datUrl,
    ${field}.previewUrl,
    ${field}.previewImg
  )
`;

export const LOGO_PROJECTTION = `
  {
    ...logo,
    "bynderLogo": ${compactBynderImageProjection('logo.bynderLogo')},
    "link": logo.link{
      ...,
      "url": ${internalReferenceUrl},
    },
    "imageUrl": ${bynderImageUrl('logo.bynderLogo')},
  }
`;
